import idx from 'idx';
import { connect } from 'react-redux';
import FocusGroups from 'focus_groups/components';

export function mapStateToProps(state) {
  const groups = idx(state, _ => _.project.focusGroups.viewState.groups) || [];
  return {
    hasGroups: groups.length > 0
  };
}

export default connect(mapStateToProps)(FocusGroups);



// WEBPACK FOOTER //
// ./focus_groups/containers/index.js